import { render, staticRenderFns } from "./fccModalTextoPadrao.vue?vue&type=template&id=0d011ff5"
import script from "./fccModalTextoPadrao.vue?vue&type=script&lang=js"
export * from "./fccModalTextoPadrao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports